import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityStatusListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Is Closed', value: 'is_closed' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/status/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityStatus']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityStatusListDetails;